﻿import { setVisibility } from "../helpers";

export function initEenmaligPage() {
    const berekenForm = document.querySelector('form[action*="Bereken"]');

    if ( berekenForm) {

        berekenForm.addEventListener('change', hideLoanPartSelector);
    }
}

function hideLoanPartSelector() {
    const loanPartSelector = document.getElementById('loanPartSelector');

    if (loanPartSelector) {
        setVisibility(loanPartSelector, false);
    }
}